export const iDokladURL = "https://app.idoklad.cz";
export const iDokladAccountURL = `${iDokladURL}/Account`;
export const iDokladLoginURL = `${iDokladAccountURL}/Login`;
export const iDokladRegistrationURL = `${iDokladAccountURL}/Registration`;